<table>
    <thead>
        <tr>
            <th class="subtable string">{{'mantenimiento-entidades-control.blockchain.registroBlockchain' | translate}}</th>
            <th class="subtable string">{{'mantenimiento-entidades-control.blockchain.registroCultivos' | translate}}</th>
            <th class="subtable string">{{'mantenimiento-entidades-control.blockchain.registroDesignaciones' | translate}}</th>
            <th class="subtable string">{{'mantenimiento-entidades-control.blockchain.registroEtiquetadoExpedicion' | translate}}</th>
            <th class="subtable string">{{'mantenimiento-entidades-control.blockchain.registroCertificado' | translate}}</th>
            <th class="subtable action"></th>
        </tr>
    </thead>
    <tbody>
        <tr [formGroup]="blockchainForm">
            <td class="short" [ngClass]="{'show-error':showError}">
                <app-filterable-list [itemsList]="yesNo" [selectedItem]="blockchainForm.get('registroBlockchain')" [disabled]="disabledBlockchain" [placeHolder]="false">
                </app-filterable-list>
            </td>
            <td class="short" [ngClass]="{'show-error':showError}">
                <app-filterable-list [itemsList]="yesNoReg" [selectedItem]="blockchainForm.get('registroCultivos')" [disabled]="disabledBlockchainChildren" [placeHolder]="false">
                </app-filterable-list>
            </td>
            <td class="short" [ngClass]="{'show-error':showError}">
                <app-filterable-list [itemsList]="yesNoReg" [selectedItem]="blockchainForm.get('registroDesignaciones')" [disabled]="disabledBlockchainChildren" [placeHolder]="false">
                </app-filterable-list>
            </td>
            <td class="short" [ngClass]="{'show-error':showError}">
                <app-filterable-list [itemsList]="yesNo" [selectedItem]="blockchainForm.get('registroEtiquetadoExpedicion')" [disabled]="disabledBlockchainChildren" [placeHolder]="false">
                </app-filterable-list>
            </td>
            <td class="short" [ngClass]="{'show-error':showError}">
                <app-filterable-list [itemsList]="yesNo" [selectedItem]="blockchainForm.get('registroCertificado')" [disabled]="disabledBlockchainChildren" [placeHolder]="false">
                </app-filterable-list>
            </td>
            <td class="multi-actions">
                <ng-container *ngIf="onEdit">
                    <i class="far fa-save" title="{{'titles.guardar' | translate}}" (click)="save()"></i>
                    <i class="fas fa-times" title="{{'global.cancelar' | translate}}" (click)="cancel()"></i>
                </ng-container>
                <ng-container *ngIf="!onEdit">
                    <i class="fas fa-pencil-alt" title="{{'titles.editar' | translate}}" (click)="enableFilters()"></i>
                </ng-container>
            </td>
        </tr>
    </tbody>
</table>